module.exports = __webpack_public_path__ + "static/media/hospital-marker.e7133dd3.svg";